import React from 'react';
import styled from 'styled-components';
import { Resident } from '../../../components/molecules/CascadedAvatars';
import { StackedAvatars } from './StackedAvatars';

export type CompactCardProps = {
  residents: Resident[];
  totalResidents: number;
  position?: 'left' | 'right';
};

const AvatarRow = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 4px;
`;

export function SocialProofStackedAvatar({
  residents,
  totalResidents,
  position = 'right',
}: Readonly<CompactCardProps>) {
  return (
    <AvatarRow>
      <StackedAvatars
        residents={residents}
        totalCount={totalResidents}
        limit={3}
        position={position}
      />
    </AvatarRow>
  );
}
